import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import categoryService from '../services/categoryService';

const FeatureOne = () => {
    const [subCategories, setSubCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_IMAGE_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5196';
    const SLIDER_MIN_ITEMS = 10; // Slider için minimum öğe sayısı
    const LOGO_PATH = "assets/images/logo/logo.png"; // Site logosu

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true);
                const response = await categoryService.getAllCategories();
                if (response.succeeded) {
                    // Alt kategorileri filtrele
                    let subCats = response.categories.filter(cat => cat.parentCategoryId !== null);
                    
                    // Alt kategorilere görsel URL'lerini düzelt
                    const processedCategories = subCats.map(category => ({
                        ...category,
                        imageUrl: category.imageUrl && !category.imageUrl.startsWith('http') 
                            ? `${API_URL}${category.imageUrl}` 
                            : category.imageUrl
                    }));
                    
                    setSubCategories(processedCategories);
                }
            } catch (error) {
                console.error('Kategoriler çekilirken hata oluştu:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, [API_URL]);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1699,
                settings: {
                    slidesToShow: 9,
                    arrows: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 8,
                    arrows: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 6,
                    arrows: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    arrows: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    arrows: false,
                    autoplay: true,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                    autoplay: true,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    autoplay: true,
                },
            },
            {
                breakpoint: 359,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    autoplay: true,
                },
            },

        ],
    };

    // Kategori öğesi renderlama fonksiyonu
    const renderCategoryItem = (category, index) => {
        // Kategori resmi kontrolü
        const hasImage = category.imageUrl && category.imageUrl.trim() !== "";
        
        return (
            <div key={category.id} className="feature-item text-center">
                <div className="feature-item__thumb rounded-circle" 
                     style={{ 
                         width: 'clamp(60px, 12vw, 80px)', 
                         height: 'clamp(60px, 12vw, 80px)',
                         margin: '0 auto'
                     }}>
                    <Link to={`/shop?category=${category.name}`} className="w-100 h-100 flex-center overflow-hidden">
                        <img 
                            src={hasImage ? category.imageUrl : LOGO_PATH} 
                            alt={category.name}
                            onError={(e) => {
                                console.error("Resim yüklenemedi:", e.target.src);
                                e.target.src = LOGO_PATH;
                            }}
                            className={!hasImage ? "p-2" : ""} // Logo gösteriliyorsa padding ekle
                            style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'contain' 
                            }}
                        />
                    </Link>
                </div>
                <div className="feature-item__content" style={{ marginTop: 'clamp(8px, 2vw, 16px)' }}>
                    <h6 className="text-lg mb-8" style={{ fontSize: 'clamp(12px, 2.5vw, 16px)' }}>
                        <Link to={`/shop?category=${category.name}`} className="text-inherit">
                            {category.name}
                        </Link>
                    </h6>
                </div>
            </div>
        );
    };

    // Yükleme durumunda
    if (loading) {
        return (
            <div className="feature" id="featureSection">
                <div className="container container-lg">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    // Alt kategorilerin sayısı slider kullanımı için yeterli mi?
    const useSlider = subCategories.length >= SLIDER_MIN_ITEMS;
    
    return (
        <div className="feature" id="featureSection">
            <div className="container container-lg">
                <div className="position-relative arrow-center">
                    {useSlider && (
                        <div className="flex-align">
                            <button
                                type="button"
                                id="feature-item-wrapper-prev"
                                className="slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                            >
                                <i className="ph ph-caret-left" />
                            </button>
                            <button
                                type="button"
                                id="feature-item-wrapper-next"
                                className="slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1"
                            >
                                <i className="ph ph-caret-right" />
                            </button>
                        </div>
                    )}
                    
                    {useSlider ? (
                        <div className="feature-item-wrapper">
                            <Slider {...settings}>
                                {subCategories.map((category, index) => (
                                    renderCategoryItem(category, index)
                                ))}
                            </Slider>
                        </div>
                    ) : (
                        <div className="row gy-4 justify-content-center">
                            {subCategories.map((category, index) => (
                                <div key={category.id} className="col-lg-2 col-md-3 col-sm-4 col-6">
                                    {renderCategoryItem(category, index)}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FeatureOne